/// <reference path="../angular.run.js" />
/// <reference path="newsletterform.services.js" />

MCApp.controller("NewsletterFormController", function ($scope, NewsletterFormServices) {

    $(".newsletter-form-wrap .angular-hide").removeClass("angular-hide");

    $scope.NewsletterForm = {};
    $scope.NewsletterForm.Name = "";
    $scope.NewsletterForm.EmailAddress = "";
    $scope.NewsletterForm.PageMadeOn = "";
    $scope.NewsletterForm.PageMadeOnUrl = "";
    $scope.NewsletterForm.GDPRAcceptance = false;
    $scope.NewsletterForm.EmailTemplateID = 0;

    $scope.FormName = "";

    // Form State
    $scope.CurrentlySendingRequest = false;
    $scope.FormSubmittedSuccessfully = false;

    $scope.SubmitNewsletterForm = function () {

        console.log($scope.NewsletterForm);

        // Response Messages
        $scope.RequestSubmissionUpdateMessage = '';
        $scope.RequestSubmissionUpdateErrors = undefined;

        // Submission Variables
        $scope.CurrentlySendingRequest = true;

        NewsletterFormServices.SubmitNewsletterForm($scope.NewsletterForm)
            .then(
                function (response) {
                    $scope.NewsletterForm = response.data;

                    if ($scope.NewsletterForm.Success == true) {
                        $scope.CurrentlySendingRequest = false;
                        $scope.FormSubmittedSuccessfully = true;

                        // Send the datalayer a message
                        if ($scope.FormName != null && $scope.FormName.length > 0) {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'formSubmission',
                                'formName': $scope.FormName
                            });
                        }

                        // Scroll to the form
                        var theNewsletterForm = $('.newsletter-form-wrap .newsletter-form');

                        $('html, body').animate({
                            scrollTop: $(theNewsletterForm).offset().top - 150
                        }, 1000);

                    } else {
                        $scope.RequestSubmissionUpdateErrors = $scope.NewsletterForm.Errors;
                    }
                    console.log($scope.NewsletterForm);
                    console.log($scope.RequestSubmissionUpdateErrors);
                },
                function (response) {
                    $scope.RequestSubmissionUpdateErrors = [];
                    $scope.RequestSubmissionUpdateErrors.push('An issue occurred when attempting to send your request.');
                }
            );
    }
});